if (!customElements.get("facet-filters-form")) {
  class FacetFiltersForm extends HTMLElement {
    // Track the latest requested sort value to prevent race conditions
    static latestSortBy = null;
    constructor() {
      super();

      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 800);

      const facetForm = this.querySelector("form");
      facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

      const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
      if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

      this.filterToggleEls = this.querySelectorAll(".facet-toggle");
      this.sortToggleEl = this.querySelector("#sort-button");
      this.filterInputEls = this.querySelectorAll(".facets__item input");

      // Listeners
      this.toggleFilterDropdowns = this.toggleFilterDropdowns.bind(this);
      this.toggleSortDropdown = this.toggleSortDropdown.bind(this.sortToggleEl);

      // Close any open toggles when clicking anywhere else on page
      const dropdownToggleEls = [
        ...document.querySelectorAll(".facet-toggle, #sort-button"),
      ];
      document.addEventListener("click", function (e) {
        if (!dropdownToggleEls.some((toggle) => toggle.contains(e.target))) {
          dropdownToggleEls.forEach((toggle) => {
            toggle.classList.remove("open");
            toggle
              .closest(".relative")
              .querySelector("fieldset")
              .classList.add("hidden");
          });
        }
      });
    }

    connectedCallback() {
      this.initFilterDropDowns();
      this.initSortDropDown();
    }

    initFilterDropDowns() {
      if (!this.filterToggleEls) return;
      this.filterToggleEls.forEach((filterButton) => {
        filterButton.addEventListener(
          "click",
          this.toggleFilterDropdowns,
          false,
        );
      });
    }

    toggleFilterDropdowns(e) {
      //close other open filters
      const opendropDownEl = document.querySelector(".facet-toggle.open");
      if (opendropDownEl) {
        if (opendropDownEl != e.target.closest(".facet-toggle")) {
          opendropDownEl.classList.remove("open");
          opendropDownEl
            .closest(".relative")
            .querySelector("fieldset")
            .classList.add("hidden");
        }
      }
      //close sort filter
      this.closeSortDropdown();

      //open selected filter
      const dropDownEl = e.target
        .closest(".relative")
        .querySelector("fieldset");
      dropDownEl.classList.toggle("hidden");
      e.target.closest(".facet-toggle").classList.toggle("open");
    }

    initSortDropDown() {
      if (!this.sortToggleEl) return;
      this.sortToggleEl.addEventListener(
        "click",
        this.toggleSortDropdown,
        false,
      );
    }

    closeSortDropdown() {
      if (!this.sortToggleEl) return;
      const filterDropDownEl = this.sortToggleEl
        .closest(".relative")
        .querySelector("fieldset");
      filterDropDownEl.classList.add("hidden");
      this.sortToggleEl.classList.remove("open");
    }

    toggleSortDropdown() {
      //close other open filters
      const opendropDownEl = document.querySelector(".facet-toggle.open");
      if (opendropDownEl) {
        opendropDownEl.classList.toggle("open");
        opendropDownEl
          .closest(".relative")
          .querySelector("fieldset")
          .classList.toggle("hidden");
      }
      //open sort filter
      const dropDownEl = this.closest(".relative").querySelector("fieldset");
      dropDownEl.classList.toggle("hidden");
      this.classList.toggle("open");
    }

    // Dawn
    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state
          ? event.state.searchParams
          : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener("popstate", onHistoryChange);
    }

    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.getElementById("ProductCount");
      const countContainerDesktop = document.getElementById(
        "ProductCountDesktop",
      );
      const loadingSpinners = document.querySelectorAll(
        ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
      );
      loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));

      if (countContainer) {
        countContainer.classList.add("loading");
      }
      if (countContainerDesktop) {
        countContainerDesktop.classList.add("loading");
      }

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;
        // Track the latest requested sort value
        try {
          const params = new URLSearchParams(url.split("?")[1]);
          FacetFiltersForm.latestSortBy = params.get("sort_by");
        } catch (e) {
          FacetFiltersForm.latestSortBy = null;
        }
        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [
            ...FacetFiltersForm.filterData,
            { html, url },
          ];
          FacetFiltersForm.renderFilters(html, event);
          // Only render product grid if sort_by is not arrival-date and this is the latest request
          let skipGrid = false;
          let thisSortBy = null;
          try {
            const params = new URLSearchParams(url.split("?")[1]);
            thisSortBy = params.get("sort_by");
            if (thisSortBy === "arrival-date") {
              skipGrid = true;
            }
          } catch (e) {}
          // Only render if this is the latest request
          if (!skipGrid && thisSortBy === FacetFiltersForm.latestSortBy) {
            FacetFiltersForm.renderProductGridContainer(html);
          }
          FacetFiltersForm.renderProductLoadMoreButton(html);
          FacetFiltersForm.renderProductCount(html);
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      // Only render product grid if sort_by is not arrival-date and this is the latest request
      let skipGrid = false;
      let thisSortBy = null;
      try {
        // Try to get sort_by from current URL
        const url = window.location.href;
        const params = new URLSearchParams(url.split("?")[1]);
        thisSortBy = params.get("sort_by");
        if (thisSortBy === "arrival-date") {
          skipGrid = true;
        }
      } catch (e) {}
      if (!skipGrid && thisSortBy === FacetFiltersForm.latestSortBy) {
        FacetFiltersForm.renderProductGridContainer(html);
      }
      FacetFiltersForm.renderProductLoadMoreButton(html);
      FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
      document.getElementById("product-grid").innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("product-grid").innerHTML;
    }

    static renderProductLoadMoreButton(html) {
      document.querySelector("collection-load-more").innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector("collection-load-more").innerHTML;
    }

    static renderProductCount(html) {
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      const count = parsedHTML.getElementById("ProductCount").innerHTML;
      const container = document.getElementById("ProductCount");
      const containerDesktop = document.getElementById("ProductCountDesktop");
      container.innerHTML = count;
      container.classList.remove("loading");
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove("loading");
      }
      const newFacetsRemove = parsedHTML.querySelector(
        ".desktop-facets__clear-wrapper",
      );
      const isFiltered = !newFacetsRemove.classList.contains("hidden");
      const desktopFacetsRemove = document.querySelector(
        ".desktop-facets__clear-wrapper",
      );
      desktopFacetsRemove.classList.toggle("hidden", !isFiltered);

      const loadingSpinners = document.querySelectorAll(
        ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
      );
      loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
    }

    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");
      const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter",
      );
      const facetDetailsElementsFromDom = document.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter",
      );

      // Remove facets that are no longer returned from the server
      Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
        if (
          !Array.from(facetDetailsElementsFromFetch).some(
            ({ id }) => currentElement.id === id,
          )
        ) {
          currentElement.remove();
        }
      });

      const matchesId = (element) => {
        const jsFilter = event ? event.target.closest(".js-filter") : undefined;
        return jsFilter ? element.id === jsFilter.id : false;
      };

      const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
        (element) => !matchesId(element),
      );
      const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
        matchesId,
      );

      facetsToRender.forEach((elementToRender, index) => {
        const currentElement = document.getElementById(elementToRender.id);
        // Element already rendered in the DOM so just update the innerHTML
        if (currentElement) {
          document.getElementById(elementToRender.id).innerHTML =
            elementToRender.innerHTML;
        } else {
          if (index > 0) {
            const {
              className: previousElementClassName,
              id: previousElementId,
            } = facetsToRender[index - 1];
            // Same facet type (eg horizontal/vertical or drawer/mobile)
            if (elementToRender.className === previousElementClassName) {
              document.getElementById(previousElementId).after(elementToRender);
              return;
            }
          }

          if (elementToRender.parentElement) {
            document
              .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
              .before(elementToRender);
          }
        }
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender) {
        const closestJSFilterID = event.target.closest(".js-filter").id;

        if (closestJSFilterID) {
          FacetFiltersForm.renderCounts(
            countsToRender,
            event.target.closest(".js-filter"),
          );
          FacetFiltersForm.renderMobileCounts(
            countsToRender,
            document.getElementById(closestJSFilterID),
          );

          const newFacetDetailsElement =
            document.getElementById(closestJSFilterID);
          const newElementSelector = newFacetDetailsElement.classList.contains(
            "mobile-facets__details",
          )
            ? `.mobile-facets__close-button`
            : `.facets__summary`;
          const newElementToActivate =
            newFacetDetailsElement.querySelector(newElementSelector);

          const isTextInput = event.target.getAttribute("type") === "text";

          if (newElementToActivate && !isTextInput)
            newElementToActivate.focus();
        }
      }
    }

    static renderActiveFacets(html) {
      const activeFacetElementSelectors = [
        ".active-facets-mobile",
        ".active-facets-desktop",
      ];

      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML =
          activeFacetsElement.innerHTML;
      });
    }

    static renderAdditionalElements(html) {
      const mobileElementSelectors = [
        ".mobile-facets__open",
        ".mobile-facets__count",
        ".sorting",
      ];

      mobileElementSelectors.forEach((selector) => {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML =
          html.querySelector(selector).innerHTML;
      });

      document
        .getElementById("FacetFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
    }

    static renderCounts(source, target) {
      const targetSummary = target.querySelector(".facets__summary");
      const sourceSummary = source.querySelector(".facets__summary");

      if (sourceSummary && targetSummary) {
        targetSummary.outerHTML = sourceSummary.outerHTML;
      }

      const targetHeaderElement = target.querySelector(".facets__header");
      const sourceHeaderElement = source.querySelector(".facets__header");

      if (sourceHeaderElement && targetHeaderElement) {
        targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
      }

      const targetWrapElement = target.querySelector(".facets-wrap");
      const sourceWrapElement = source.querySelector(".facets-wrap");

      if (sourceWrapElement && targetWrapElement) {
        const isShowingMore = Boolean(
          target.querySelector("show-more-button .label-show-more.hidden"),
        );
        if (isShowingMore) {
          sourceWrapElement
            .querySelectorAll(".facets__item.hidden")
            .forEach((hiddenItem) =>
              hiddenItem.classList.replace("hidden", "show-more-item"),
            );
        }

        targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
      }
    }

    static renderMobileCounts(source, target) {
      const targetFacetsList = target.querySelector(".mobile-facets__list");
      const sourceFacetsList = source.querySelector(".mobile-facets__list");

      if (sourceFacetsList && targetFacetsList) {
        targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
      }
    }

    static updateURLHash(searchParams) {
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
      );
    }

    static getSections() {
      return [
        {
          section: document.getElementById("product-grid").dataset.id,
        },
      ];
    }

    createSearchParams(form) {
      const formData = new FormData(form);
      // Check if "show_in_stock_only" is true
      const showInStockOnly =
        formData.get("filter.s.show_in_stock_only") === "true";

      // Helper function to count matching "filter.*" keys
      const countFilterKeys = (formData) => {
        return Array.from(formData.keys()).filter(
          (key) =>
            key.startsWith("filter.") &&
            key !== "filter.v.availability" &&
            !key.startsWith("filter.s"),
        ).length;
      };

      if (showInStockOnly) {
        const hasAvailability = formData.has("filter.v.availability");
        const otherFilterCount = countFilterKeys(formData);

        if (!hasAvailability && otherFilterCount > 0) {
          // Add 'filter.v.availability' = 1
          formData.set("filter.v.availability", "1");
        } else if (hasAvailability && otherFilterCount === 0) {
          // Remove 'filter.v.availability' if it's the only key
          formData.delete("filter.v.availability");
        }
      }

      // Always remove "filter.s.show_in_stock_only" from the formData
      formData.delete("filter.s.show_in_stock_only");
      return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const sortFilterForms = document.querySelectorAll(
        "facet-filters-form form",
      );
      if (event.srcElement.className == "mobile-facets__checkbox") {
        const searchParams = this.createSearchParams(
          event.target.closest("form"),
        );
        this.onSubmitForm(searchParams, event);
      } else {
        const forms = [];
        let isMobile = false;
        if (event.target.closest("form").id === "FacetFiltersFormMobile") {
          isMobile = true;
        } else if (event.target.closest("form").id === "FacetSortFormMobile") {
          isMobile = true;
        }

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (
              form.id === "FacetSortForm" ||
              form.id === "FacetFiltersForm" ||
              form.id === "FacetSortDrawerForm"
            ) {
              forms.push(this.createSearchParams(form));
            }
          } else if (
            form.id === "FacetFiltersFormMobile" ||
            form.id === "FacetSortFormMobile"
          ) {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join("&"), event);
      }
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      const url =
        event.currentTarget.href.indexOf("?") == -1
          ? ""
          : event.currentTarget.href.slice(
              event.currentTarget.href.indexOf("?") + 1,
            );
      FacetFiltersForm.renderPage(url);
    }
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define("facet-filters-form", FacetFiltersForm);
  FacetFiltersForm.setListeners();

  // sort by arrival logic

  // Format the text metafield into a date
  function parseArrivalDate(dateStr) {
    if (!dateStr) return null;
    const parts = dateStr.split("-");
    if (parts.length !== 3) return null;
    let [d, m, y] = parts;
    if (y.length === 2) y = "20" + y;
    return new Date(`${y}-${m}-${d}`);
  }

  // Product card rendering
  function renderProductCard(product) {
    // Render swatches if present
    let swatchesHtml = "";
    if (
      product.swatches === true &&
      Array.isArray(product.variations_by_colour) &&
      product.variations_by_colour.length > 0
    ) {
      swatchesHtml += `<div class="flex gap-2 w-full flex-wrap pt-1">`;
      // Main product swatch
      swatchesHtml += `
        <a href="${product.url}" class="cursor-pointer hover:opacity-75 p-[3px] border-2 border-black" data-second-image="${product.images && product.images[1] ? product.images[1] : ""}" data-colour-swatch>
          <div class="aspect-[3/4] w-[42px] h-full${!product.available ? " cross-out-container cross-out-container--crossed-out [&>svg>line]:stroke-gray-300 [&>svg>line]:stroke-1 relative" : ""}">
            <svg class="cross-out z-10${product.available ? " hidden" : ""}"><line x1='0' y1='0' x2='100%' y2='100%' /></svg>
            <img src="${product.images && product.images[0] ? product.images[0] : product.image}" class="block !object-cover w-full h-full" alt="${product.title}">
            ${!product.available ? `<img src="${product.images && product.images[0] ? product.images[0] : product.image}" class="block !object-cover w-full h-full" alt="${product.title}">` : ""}
          </div>
        </a>
      `;
      // Other colour variations
      product.variations_by_colour.forEach((variation) => {
        if (variation.handle === product.handle) return;
        swatchesHtml += `
          <a href="${variation.url}" class="cursor-pointer hover:opacity-75 p-1${variation.id === product.id ? " border-2 border-black p-[3px]" : " border border-gray-400"}" data-second-image="${variation.images && variation.images[1] ? variation.images[1] : ""}" data-colour-swatch>
            <div class="aspect-[3/4] w-[42px] h-full${!variation.available ? " cross-out-container cross-out-container--crossed-out [&>svg>line]:stroke-gray-300 [&>svg>line]:stroke-1 relative" : ""}">
              <svg class="cross-out z-10${variation.available ? " hidden" : ""}"><line x1='0' y1='0' x2='100%' y2='100%' /></svg>
              <img src="${variation.images && variation.images[0] ? variation.images[0] : variation.image}" class="block object-cover w-full h-full" alt="${variation.title}">
              ${!variation.available ? `<img src="${variation.images && variation.images[0] ? variation.images[0] : variation.image}" class="block !object-cover w-full h-full" alt="${variation.title}">` : ""}
            </div>
          </a>
        `;
      });
      swatchesHtml += `</div>`;
    }

    return `
      <li class="product-grid__item">
        <product-card data-arrival-date="${product.arrival_date || ""}" data-product-handle="${product.handle}" class="product-card">
          <div class="relative h-full flex flex-col">
            <div class="top-2 absolute left-2 flex flex-wrap gap-2 z-10">
              ${(product.badges || []).map((badge) => `<span class="bg-primary-2 text-white font-normal px-3 py-1 leading-4 md:leading-5 uppercase">${badge}</span>`).join("")}
            </div>
            <div class="relative group aspect-[3/4]">
              <a href="${product.url}" title="${product.title}">
                <img src="${product.images && product.images[0] ? product.images[0] : product.image}" class="w-full h-full object-cover" alt="${product.title}">
                ${product.images && product.images[1] ? `<img src="${product.images[1]}" class="w-full h-full object-cover absolute inset-0 opacity-0 transition-opacity duration-500 ease-in-out group-hover:opacity-100" alt="${product.title}">` : ""}
                <img data-swatch-image aria-hidden="true" alt="Swatch image" class="absolute inset-0 w-full h-full object-cover hidden">
              </a>
              ${!product.available ? `<div class="block absolute bg-black opacity-40 top-0 bottom-0 left-0 right-0 w-full h-full pointer-events-none"></div>` : ""}
            </div>
            <h3 class="flex flex-col flex-wrap justify-between ">
              <a class="mt-4 text-base font-medium text-gray-900 leading-normal" href="${product.url}">
                ${product.title}
              </a>
              <div class="jdgm-widget jdgm-preview-badge text-xs md:text-sm font-light capitalize leading-[13px] md:leading-5 text-gray-600" data-id="${product.handle}">
                ${product.judgeme_badge || ""}
              </div>
            </h3>
            <div class="my-2 text-[15px] md:text-sm leading-[1.4] md:leading-5">
              ${
                product.compare_at_price > product.price
                  ? `
                <span class="flex gap-1 items-center">
                  <span class="line-through">${(product.compare_at_price / 100).toLocaleString("en-GB", { style: "currency", currency: "GBP" })}</span>
                  <span class="text-gray-600">Full price</span>
                </span>
              `
                  : ""
              }
              <div class="flex gap-1 items-center">
                <span>
                  ${product.price_varies ? `From ${(product.price_min / 100).toLocaleString("en-GB", { style: "currency", currency: "GBP" })}` : (product.price / 100).toLocaleString("en-GB", { style: "currency", currency: "GBP" })}
                </span>
                ${
                  product.compare_at_price > product.price
                    ? `
                  <span class="text-center">${product.compare_at_label || ""}</span>
                  <span class="text-center bg-dark-green text-white text-[11px] font-normal px-2 py-0.5 leading-normal">
                    ${Math.round((100 * (product.compare_at_price - product.price)) / product.compare_at_price)}% OFF
                  </span>
                `
                    : ""
                }
              </div>
            </div>
            ${swatchesHtml}
          </div>
        </product-card>
      </li>
    `;
  }

  // Pagination handling
  let arrivalDateProducts = [];
  let arrivalDatePage = 1;
  let arrivalDatePerPage = 0;
  let arrivalDateTotalPages = 0;

  async function sortProductsByArrivalDate(
    resetPage = true,
    searchParamsArg = null,
  ) {
    // [Sort by arrival] Fetching all products across all pages for sorting...
    const grid = document.getElementById("product-grid");
    if (!grid) {
      return;
    }
    // Find section id for AJAX fetch
    const sectionId = grid.dataset.id;
    // Use passed searchParams if available, else fallback to url
    let searchParams;
    if (searchParamsArg) {
      searchParams = new URLSearchParams(searchParamsArg);
    } else {
      searchParams = new URLSearchParams(window.location.search);
    }
    // Remove page param if present
    searchParams.delete("page");
    // Remove section_id if present
    searchParams.delete("section_id");
    // Remove any existing sort by, since we're ordering it
    searchParams.delete("sort_by");
    // Log all filters being applied
    // const appliedFilters = [];
    // for (const [key, value] of searchParams.entries()) {
    //   if (key.startsWith("filter.")) {
    //     appliedFilters.push(`${key}=${value}`);
    //   }
    // }
    // console.log(
    //   "[Sort by arrival] Filters being applied:",
    //   appliedFilters.length ? appliedFilters : "(none)",
    // );
    // Add any other filters going on
    let baseUrl = `${window.location.pathname}?section_id=${sectionId}`;
    if (searchParams.toString()) baseUrl += `&${searchParams.toString()}`;
    // [Sort by arrival] AJAX fetch baseUrl: baseUrl

    // Fetch the first page to get filtered product count and perPage
    let firstPageUrl = `${baseUrl}&page=1`;
    let firstPageHtml = await fetch(firstPageUrl).then((r) => r.text());
    const firstDoc = new DOMParser().parseFromString(
      firstPageHtml,
      "text/html",
    );
    // Get perPage and filtered total from the first page
    const perPage = parseInt(
      firstDoc.querySelector("[data-products-per-page]")?.dataset
        .productsPerPage || firstDoc.querySelectorAll(".product-card").length,
    );
    const totalProducts = parseInt(
      firstDoc.querySelector("[data-total-products]")?.dataset.totalProducts ||
        firstDoc.querySelectorAll(".product-card").length,
    );
    if (!sectionId || !totalProducts || !perPage) {
      console.warn(
        "[Sort by arrival] Missing sectionId, totalProducts, or perPage. Aborting.",
        { sectionId, totalProducts, perPage },
      );
      return;
    }
    arrivalDatePerPage = perPage;
    const totalPages = Math.ceil(totalProducts / perPage);
    arrivalDateTotalPages = totalPages;

    // Fetch all filtered pages
    let allProducts = [];
    let fetches = [];
    for (let page = 1; page <= totalPages; page++) {
      let url = `${baseUrl}&page=${page}`;
      fetches.push(
        fetch(url)
          .then((r) => r.text())
          .then((html) => {
            // Parse the returned HTML and extract the JSON
            const doc = new DOMParser().parseFromString(html, "text/html");
            const productsJson = doc.getElementById("all-products-json");
            if (!productsJson) {
              return [];
            }
            try {
              const parsed = JSON.parse(productsJson.textContent);
              // [Sort by arrival] Page ${page} returned ${parsed.length} products.
              return parsed;
            } catch (e) {
              return [];
            }
          }),
      );
    }
    // Wait for all fetches
    const results = await Promise.all(fetches);
    results.forEach((arr, idx) => {
      if (Array.isArray(arr)) {
        allProducts = allProducts.concat(arr);
      } else {
        console.warn(
          `[Sort by arrival] Page ${idx + 1} did not return an array.`,
        );
      }
    });
    // Log of all products to show
    // console.log(
    //   `[Sort by arrival] Total products fetched across all pages:`,
    //   allProducts.length,
    // );
    // Remove duplicates
    const seen = new Set();
    allProducts = allProducts.filter((p) => {
      if (seen.has(p.handle)) return false;
      seen.add(p.handle);
      return true;
    });
    // Log filtered products before sorting
    // console.log(
    //   "[Sort by arrival] Filtered products before sorting:",
    //   allProducts.map((p) => `${p.title} (${p.arrival_date})`),
    // );
    // Sort by arrival date
    allProducts.sort((a, b) => {
      const dateA = parseArrivalDate(a.arrival_date);
      const dateB = parseArrivalDate(b.arrival_date);
      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;
      return dateA - dateB;
    });
    // Log filtered products after sorting
    // console.log(
    //   "[Sort by arrival] Filtered products after sorting:",
    //   allProducts.map((p) => `${p.title} (${p.arrival_date})`),
    // );
    arrivalDateProducts = allProducts;
    if (resetPage) arrivalDatePage = 1;
    renderArrivalDatePage();
    setupArrivalDateLoadMore();
  }

  function renderArrivalDatePage() {
    const grid = document.getElementById("product-grid");
    if (!grid) return;
    if (arrivalDatePage === 1) {
      grid.innerHTML = "";
    }
    const start = (arrivalDatePage - 1) * arrivalDatePerPage;
    const end = Math.min(
      arrivalDatePage * arrivalDatePerPage,
      arrivalDateProducts.length,
    );
    const toRender = arrivalDateProducts.slice(start, end);
    grid.insertAdjacentHTML(
      "beforeend",
      toRender.map(renderProductCard).join(""),
    );
    // Always update the load more button visibility after rendering, in case filters mean theres no pagination
    const arrivalBtn = document.getElementById("arrival-date-load-more");
    if (arrivalBtn) {
      const textSpan = arrivalBtn.querySelector("[data-load-more-text]");
      const total = arrivalDateProducts.length;
      const showing = end;
      const remaining = total - showing;
      let shouldHide = false;
      let reason = "";
      if (total === 0) {
        // No products to show
        shouldHide = true;
      } else if (showing >= total) {
        // All products shown
        shouldHide = true;
      } else if (remaining <= 0) {
        // All products shown
        shouldHide = true;
      }
      if (shouldHide) {
        arrivalBtn.classList.add("hidden");
        arrivalBtn.setAttribute("aria-hidden", "true");
        arrivalBtn.setAttribute("tabindex", "-1");
        arrivalBtn.style.display = "none";
        if (textSpan) textSpan.textContent = "";
      } else {
        arrivalBtn.classList.remove("hidden");
        arrivalBtn.setAttribute("aria-hidden", "false");
        arrivalBtn.removeAttribute("tabindex");
        arrivalBtn.style.display = "";
        const number = Math.min(arrivalDatePerPage, remaining);
        if (textSpan) textSpan.textContent = `Load more (${number})`;
      }
    }
  }

  // Load more logic for sort by arrival date
  // This is needed because the default load more runs off Shopify pagination, which isn't the ruleset we're following for custom arrival date sorting
  function setupArrivalDateLoadMore() {
    // Only handle the custom button for arrival-date
    const arrivalBtn = document.getElementById("arrival-date-load-more");
    if (!arrivalBtn) return;
    // Remove all previous listeners
    const newBtn = arrivalBtn.cloneNode(true);
    arrivalBtn.parentNode.replaceChild(newBtn, arrivalBtn);
    newBtn.classList.remove("hidden");
    newBtn.addEventListener("click", function (e) {
      e.preventDefault();
      arrivalDatePage++;
      renderArrivalDatePage();
    });
  }

  function handleArrivalDateSort(searchParamsArg = null) {
    // [Sort by arrival] Checking if arrival-date is selected
    const sortInputs = document.querySelectorAll('input[name="sort_by"]');
    const checkedInputs = Array.from(sortInputs).filter(
      (input) => input.checked,
    );
    // checkedInputs.forEach((input) => {
    //   const label = input.nextElementSibling
    //     ? input.nextElementSibling.textContent.trim()
    //     : "";
    //   [Sort by arrival] Checked input value: input.value | Label: label
    // });
    // If any checked input is arrival-date, trigger logic
    let isArrivalDate = checkedInputs.some(
      (input) => input.value === "arrival-date",
    );
    // if none checked, check URL param (for page load)
    if (!isArrivalDate) {
      const params = new URLSearchParams(window.location.search);
      if (params.get("sort_by") === "arrival-date") {
        isArrivalDate = true;
      }
    }
    // [Sort by arrival] Arrival-date selected? isArrivalDate
    const loadMoreBtn = document.querySelector("collection-load-more");
    const arrivalBtn = document.getElementById("arrival-date-load-more");
    if (arrivalBtn) {
      if (isArrivalDate) {
        arrivalBtn.classList.remove("hidden");
        arrivalBtn.setAttribute("aria-hidden", "false");
        arrivalBtn.removeAttribute("tabindex");
      } else {
        arrivalBtn.classList.add("hidden");
        arrivalBtn.setAttribute("aria-hidden", "true");
        arrivalBtn.setAttribute("tabindex", "-1");
      }
    }
    if (isArrivalDate) {
      if (loadMoreBtn) loadMoreBtn.classList.add("hidden");
      // reset ready for sorting
      arrivalDatePage = 1;
      // Get all filters for sorting, using URL and filter forms.
      // Will de-duplicate doubles
      const urlParams = new URLSearchParams(window.location.search);
      let formParams = new URLSearchParams();
      const activeForm =
        document.querySelector("form#FacetFiltersForm") ||
        document.querySelector("form#FacetFiltersFormMobile");
      if (activeForm) {
        const formData = new FormData(activeForm);
        formParams = new URLSearchParams(formData);
      }
      let eventParams = new URLSearchParams();
      if (searchParamsArg) {
        eventParams = new URLSearchParams(searchParamsArg);
      }
      const filterPairs = [];
      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith("filter.")) filterPairs.push(`${key}=${value}`);
      }
      for (const [key, value] of formParams.entries()) {
        if (key.startsWith("filter.")) filterPairs.push(`${key}=${value}`);
      }
      for (const [key, value] of eventParams.entries()) {
        if (key.startsWith("filter.")) filterPairs.push(`${key}=${value}`);
      }
      // Deduplicate
      const uniqueFilterPairs = Array.from(new Set(filterPairs));
      // Build mergedParams
      const mergedParams = new URLSearchParams();
      uniqueFilterPairs.forEach((pair) => {
        const eqIdx = pair.indexOf("=");
        if (eqIdx > 0) {
          const key = pair.slice(0, eqIdx);
          const value = pair.slice(eqIdx + 1);
          mergedParams.append(key, value);
        }
      });
      // Always add show_in_stock_only if present in form
      // Previous client request to only show in stock when filtered, so maintaining that
      if (formParams.has("filter.s.show_in_stock_only")) {
        mergedParams.set(
          "filter.s.show_in_stock_only",
          formParams.get("filter.s.show_in_stock_only"),
        );
      }
      // Add sort_by=arrival-date
      mergedParams.set("sort_by", "arrival-date");
      // Pass merged param string
      sortProductsByArrivalDate(true, mergedParams.toString());
      setupArrivalDateLoadMore();
    } else {
      if (loadMoreBtn) loadMoreBtn.classList.remove("hidden");
    }
  }

  // On page load, always hide the arrival-date load more button by default
  document.addEventListener("DOMContentLoaded", function () {
    const arrivalBtn = document.getElementById("arrival-date-load-more");
    if (arrivalBtn) {
      arrivalBtn.classList.add("hidden");
      arrivalBtn.setAttribute("aria-hidden", "true");
      arrivalBtn.setAttribute("tabindex", "-1");
    }

    // If sort_by=arrival-date is in the URL, immediately run the logic
    const params = new URLSearchParams(window.location.search);
    // [Sort by arrival] Checking URL parameters on page load: params.toString()
    if (params.get("sort_by") === "arrival-date") {
      handleArrivalDateSort();
    }
  });

  // Listen for any filter or sort change (desktop & mobile)
  document.addEventListener("change", function (e) {
    // If a filter or sort is changed, check if arrival-date is selected and trigger logic
    const isSortChange = e.target && e.target.name === "sort_by";
    const isFilterChange =
      e.target &&
      e.target.form &&
      (e.target.form.id === "FacetFiltersForm" ||
        e.target.form.id === "FacetFiltersFormMobile");
    if (isSortChange || isFilterChange) {
      setTimeout(() => {
        // Pass the latest param from the form
        let searchParamsStr = null;
        if (e.target && e.target.form) {
          const formData = new FormData(e.target.form);
          searchParamsStr = new URLSearchParams(formData).toString();
        }
        handleArrivalDateSort(searchParamsStr);
      }, 1000); // Delay needed to let URL update beforehand
    }
  });
}
